import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { EvolysProvider, installDeploymentRecovery } from "@evolys/ui";
import "@mantine/core/styles.css";
import "./styles.css";
import { App } from "./App";

installDeploymentRecovery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <EvolysProvider forceColorScheme="light">
      <App />
    </EvolysProvider>
  </StrictMode>,
);
